import { Grade } from '@brighterly/lib-core-types/kid/enums'

const GRADE_LABELS: Record<Grade, string> = {
  [Grade.K]: 'Kindergarten',
  [Grade.K1]: 'Grade 1',
  [Grade.K2]: 'Grade 2',
  [Grade.K3]: 'Grade 3',
  [Grade.K4]: 'Grade 4',
  [Grade.K5]: 'Grade 5',
  [Grade.K6]: 'Grade 6',
  [Grade.K7]: 'Grade 7',
  [Grade.K8]: 'Grade 8',
  [Grade.K9]: 'Grade 9',
  [Grade.K10]: 'Grade 10',
  [Grade.K11]: 'Grade 11',
  [Grade.K12]: 'Grade 12',
}

export const getGradeLabel = (grade: Grade | null): string => (grade ? GRADE_LABELS[grade] || '' : '')
